import { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import Layouts from "../../layouts/layouts";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBroom, faCalendarDays } from "@fortawesome/free-solid-svg-icons";

export default function PurgeData() {
  const title = "Purge Data";

  const handleClear3Month = async () => {
    try {
      const token = localStorage.getItem("token");
      await axios.delete(
        `${process.env.REACT_APP_BASE_URL}/api/v1/vehicle-history/delete-old-history`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      Swal.fire("✅ Success", "Old vehicle history cleared.", "success");
    } catch (error) {
      Swal.fire("❌ Error", "Failed to clear history.", "error");
      console.error(error);
    }
  };

  const handleClearByDate = async () => {
    const { value: formValues } = await Swal.fire({
      title: "🗓 Select Date Range",
      html:
        `<input id="from-date" type="date" class="swal2-input" placeholder="From Date">` +
        `<input id="to-date" type="date" class="swal2-input" placeholder="To Date">`,
      confirmButtonText: "🧹 Clear",
      cancelButtonText: "Cancel",
      showCancelButton: true,
      focusConfirm: false,
      preConfirm: () => {
        const fromDate = document.getElementById("from-date").value;
        const toDate = document.getElementById("to-date").value;
        if (!fromDate || !toDate) {
          Swal.showValidationMessage("Both dates are required");
        }
        return { fromDate, toDate };
      },
    });

    if (formValues) {
      try {
        const token = localStorage.getItem("token");
        await axios.delete(
          `${process.env.REACT_APP_BASE_URL}/api/v1/vehicle-history/delete-old-history/by-date-range?fromDate=${formValues.fromDate}&toDate=${formValues.toDate}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        Swal.fire(
          "✅ Success",
          "History deleted for selected range.",
          "success"
        );
      } catch (error) {
        Swal.fire("❌ Error", "Failed to delete history by date.", "error");
        console.error(error);
      }
    }
  };

  return (
    <>
      <Layouts />
      <div className="container mt-5">
        <div className="card shadow rounded-4 border-0">
          <div
            className="card-header bg-gradient p-4 text-white"
            style={{ background: "#4723d9" }}
          >
            <h3 className="m-0">{title}</h3>
          </div>
          <div className="card-body p-4">
            <div className="row g-4 justify-content-center">
              {/* 3 Month Clear Button */}
              <div className="col-md-5">
                <div className="card border-0 shadow-sm h-100 text-center p-4">
                  <FontAwesomeIcon
                    icon={faBroom}
                    size="2x"
                    className="mb-3 text-danger"
                  />
                  <h5>Clear Last 3 Months</h5>
                  <p className="text-muted">
                    Deletes all vehicle history older than 3 months.
                  </p>
                  <button
                    className="btn btn-outline-danger px-4"
                    onClick={handleClear3Month}
                  >
                    <FontAwesomeIcon icon={faBroom} className="me-2" />
                    Clear Vehicle History
                  </button>
                </div>
              </div>

              {/* Date Range Clear */}
              <div className="col-md-5">
                <div className="card border-0 shadow-sm h-100 text-center p-4">
                  <FontAwesomeIcon
                    icon={faCalendarDays}
                    size="2x"
                    className="mb-3 text-warning"
                  />
                  <h5>Clear By Date Range</h5>
                  <p className="text-muted">
                    Select custom date range to delete specific records.
                  </p>
                  <button
                    className="btn btn-outline-warning px-4"
                    onClick={handleClearByDate}
                  >
                    <FontAwesomeIcon icon={faCalendarDays} className="me-2" />
                    Select Date
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
